<section class="esign-amortization-plan-document">
  <div class="header">
    <h1>{{ 'COMMON.SEND_FOR_DIGITAL_SIGNING_DOCUMENT' | translate }}</h1>
  </div>

  <app-information-block [text]="'AMORTIZATION_PLAN.ESIGN_HELP_TEXT' | translate"></app-information-block>

  <form class="astral-content-width astral-stack-l" [formGroup]="form">
    <section class="astral-section-surface astral-stack-m">
      <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
        <astral-input
          [label]="'COMPANY.EDIT_HEADER'"
          [value]="companyName"
          [readonly]="true"
        ></astral-input>
        <astral-input
          [label]="'COMMON.CONTACT'"
          [value]="debtorContactName"
          [readonly]="true"
        ></astral-input>
        <div class="astral-form-adjacent-action">
          <astral-button
            variant="secondary"
            type="button"
            icon="pdf"
            labelKey="PREVIEW_BTN"
            (click)="previewForm()"
          ></astral-button>
        </div>
        <astral-toggle
          [control]="form.controls['informWhenSigned']"
          [helpText]="'ESIGNATURE.HELP_TEXT.INFORM_WHEN_SIGNED'"
        ></astral-toggle>

        <astral-input
          [span]="2"
          [control]="form.controls['errandDescription']"
          [helpText]="'ESIGNATURE.HELP_TEXT.DESCRIPTION'"
        ></astral-input>
        <astral-date-picker
          [control]="form.controls['expirationDate']"
          [label]="'ESIGNATURE.EXPIRATION_DATE'"
          [model]="expirationDate"
          [helpText]="'ESIGNATURE.HELP_TEXT.EXPIRATION_DATE'"
        ></astral-date-picker>
        @if (form.controls['informWhenSigned'].value) {
          <astral-input
            [control]="form.controls['informEmailAddress']"
            [helpText]="'ESIGNATURE.HELP_TEXT.INFORM_EMAIL_ADRESSES'"
          ></astral-input>
        }
      </astral-layout-group>
    </section>

    <section class="astral-stack-m">
      <h4>{{ 'ESIGNATURE.SIGNATORIES' | translate }}</h4>

      <div class="astral-stack-m">
        @for (sform of signatoryForms; track sform; let i = $index) {
          <section
            class="astral-section-surface astral-stack-m"
            >
            <h5>
              {{ 'ESIGNATURE.SIGNATORY_X_OF_Y' | translate : { current: i + 1, total: signatoryForms.length } }}
            </h5>
            <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
              <astral-input [control]="sform.controls['name']"></astral-input>
              <astral-select
                [control]="sform.controls['informationChannel']"
                [itemsSource]="informationChannels"
                [helpText]="'ESIGNATURE.HELP_TEXT.INFORMATION_CHANNEL'"
              ></astral-select>
              <app-email-box [control]="sform.controls['email']"></app-email-box>
              <astral-input type="phone" inputMode="tel" [control]="sform.controls['phone']"></astral-input>
              <astral-select
                [control]="sform.controls['signingRole']"
                [itemsSource]="signingRoles"
                [helpText]="'ESIGNATURE.HELP_TEXT.SIGNING_ROLE'"
              ></astral-select>
              <astral-select
                [control]="sform.controls['signatureType']"
                [itemsSource]="signatureTypeSelection"
              ></astral-select>
              <astral-masked-input
                [control]="sform.controls['civicNumber']"
                [mask]="civicNumberMask"
                [helpText]="'ESIGNATURE.HELP_TEXT.CIVIC_NUMBER'"
                [maskFormat]="civicNumberMaskFormat"
              ></astral-masked-input>
              <astral-select
                [control]="sform.controls['signatureReminderSetting']"
                [helpText]="'ESIGNATURE.HELP_TEXT.SIGNATURE_REMINDER_SETTING'"
                [itemsSource]="signatureReminderSettingSelection"
              ></astral-select>
              @if (i > 0) {
                <div class="astral-form-adjacent-action">
                  <astral-button
                    variant="secondary"
                    size="small"
                    type="button"
                    icon="trash"
                    labelKey="DELETE_BTN"
                    (click)="deleteSignatory(i)"
                  ></astral-button>
                </div>
              }
            </astral-layout-group>
          </section>
        }
      </div>

      <div class="astral-form-actions">
        <astral-button
          variant="primary"
          size="small"
          type="button"
          icon="plus"
          labelKey="ESIGNATURE.ADD_SIGNATORY"
          (click)="newSignatory()"
        ></astral-button>
      </div>
    </section>

    <section class="astral-section-surface astral-stack-m">
      <app-file-upload
        [text]="'ESIGNATURE.ADD_ATTACHMENT'"
        [forms]="form.controls['attachments']"
        [allowedMimeTypes]="['application/pdf']"
        buttonVariant="primary"
      ></app-file-upload>
    </section>

    <div class="astral-form-actions">
      <astral-button
        variant="primary"
        type="button"
        labelKey="COMMON.SEND"
        [disabled]="form.disabled"
        (click)="save()"
      ></astral-button>
      <astral-button
        variant="secondary"
        type="button"
        labelKey="CANCEL_BTN"
        [disabled]="form.disabled"
        (click)="cancel()"
      ></astral-button>
    </div>
  </form>
</section>
